module.exports = __webpack_public_path__ + "img/faq6.9791f967.png";